if (!customElements.get('bio-loved')) {
  customElements.define(
    'bio-loved',
    class BioLoved extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-blv-track]');
        this.prev = this.querySelector('[data-blv-prev]');
        this.next = this.querySelector('[data-blv-next]');
        this.update = this.update.bind(this);

        this.prev.addEventListener('click', () => this.step(-1));
        this.next.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.addEventListener('click', (event) => {
          const more = event.target.closest('[data-blv-more]');
          if (more) this.toggle(more);
        });

        this.resize = new ResizeObserver(() => {
          this.measure();
          this.update();
        });
        this.resize.observe(this.track);

        const ring = this.querySelector('.blv__ring');
        if (ring && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('is-pending');
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              this.classList.add('is-drawn');
              this.classList.remove('is-pending');
              this.observer.disconnect();
            },
            { threshold: 0.4 }
          );
          this.observer.observe(this.querySelector('.blv__heading'));
        }
      }

      disconnectedCallback() {
        this.resize?.disconnect();
        this.observer?.disconnect();
      }

      measure() {
        const photo = this.track.querySelector('.blv__photo');
        if (photo) this.style.setProperty('--blv-arrow-top', `${photo.offsetHeight / 2}px`);
        this.querySelectorAll('[data-blv-more]').forEach((button) => {
          const text = document.getElementById(button.getAttribute('aria-controls'));
          if (!text || text.classList.contains('is-open')) return;
          button.hidden = text.scrollHeight <= text.clientHeight + 1;
        });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.classList.toggle('is-static', max < 2);
        this.prev.disabled = this.track.scrollLeft < 4;
        this.next.disabled = this.track.scrollLeft > max - 4;
      }

      step(direction) {
        const card = this.track.querySelector('.blv__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      toggle(button) {
        const text = document.getElementById(button.getAttribute('aria-controls'));
        const open = !text.classList.contains('is-open');
        text.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open);
        if (!button.dataset.more) button.dataset.more = button.textContent;
        button.textContent = open ? button.dataset.less : button.dataset.more;
      }
    }
  );
}
